import { useEffect, useMemo, useState } from 'react';

export const useKeyPress = (targetKey: string): boolean => {
  const [keyPressed, setKeyPressed] = useState(false);
  const keys = useMemo(
    () => targetKey.split(',').map((key) => key.trim()),
    [targetKey],
  );

  const downHandler = ({ key }: KeyboardEvent): void => {
    if (keys.some((value) => value === key)) {
      setKeyPressed(true);
    }
  };

  const upHandler = ({ key }: KeyboardEvent): void => {
    if (keys.some((value) => value === key)) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);
  return keyPressed;
};
